import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=ba96ee4a&"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba96ee4a')) {
      api.createRecord('ba96ee4a', component.options)
    } else {
      api.reload('ba96ee4a', component.options)
    }
    module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=ba96ee4a&", function () {
      api.rerender('ba96ee4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/base-checkbox/BaseCheckbox.vue"
export default component.exports